import React, { useEffect, useRef, useState } from "react";
import music from "../assets/music.mp3";

export default function AudioPlayer() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [autoplayTried, setAutoplayTried] = useState(false);

  useEffect(() => {
    const audio = new Audio(music);
    audioRef.current = audio;
    audio.loop = true;
    audio.preload = "auto";
    audio.volume = 0.5; 

    const tryAutoplay = async () => {
      try {
        await audio.play();
        setIsPlaying(true);
      } catch {
        setIsPlaying(false);
      } finally {
        setAutoplayTried(true);
      }
    };
    tryAutoplay();

    const onFirstGesture = () => {
      if (!audioRef.current) return;
      if (audioRef.current.paused) {
        audioRef.current.play().then(() => setIsPlaying(true)).catch(() => {});
      }
      window.removeEventListener("pointerdown", onFirstGesture);
      window.removeEventListener("keydown", onFirstGesture);
      window.removeEventListener("touchend", onFirstGesture);
    };

    window.addEventListener("pointerdown", onFirstGesture, { once: true });
    window.addEventListener("keydown", onFirstGesture, { once: true });
    window.addEventListener("touchend", onFirstGesture, { once: true });

    return () => {
      try { audio.pause(); } catch {}
      audio.src = "";
      audioRef.current = null;
    };
  }, []);

  const togglePlay = async () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      try { await audio.play(); setIsPlaying(true); } catch {}
    } else {
      audio.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="audio-player" role="region" aria-label="Site music player">
      <button
        className="audio-btn"
        onClick={togglePlay}
        aria-label={isPlaying ? "Pause music" : "Play music"}
      >
        {isPlaying ? (
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="5" y="4" width="5" height="16" rx="1"></rect>
            <rect x="14" y="4" width="5" height="16" rx="1"></rect>
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 4l14 8-14 8z"></path>
          </svg>
        )}
      </button>

    </div>
  );
}
